module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'extra-padding': !_vm.allowPageChange
    }
  }, [(_vm.totalResults && _vm.activePage) ? _c('small', [_c('b', [_vm._v(_vm._s(_vm.pageStart))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.pageEnd))]), _vm._v(" of "), _c('b', [_vm._v(_vm._s(_vm.totalResults))]), _vm._v(" results")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('b', {
    staticClass: "margin-left-5 margin-right-5"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('small', [_vm._v("Show")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.resultsPerPage) + "\n\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, _vm._l((_vm.resultOptions), function(result) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.updateResultsPerPage(result)
        }
      }
    }, [_vm._v(_vm._s(result))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('small', [_vm._v("Results Per Page")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-593b571c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/PageResults.vue
// module id = 433
// module chunks = 1